import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/thumbDownFilled.svg';

export const IconThumbDownFilled = createIconComponent(Icon);
